import { createRouter, createWebHashHistory, RouteLocationNormalized } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import localCache from "@/utils/cache";
import Layout from '@/views/main/Main.vue'
import platformRouter from './main/platform/'
import systemRouter from './main/system/'
import missionRouter from './main/mission'
import tagPrintingRouter from './main/tagPrinting'
import supplierRouter from './main/supplier/'
import statisticalRouter from './main/statistical/'
import warehouseRouter from './main/warehouse'
import invoicesRouter from './main/invoices'
import checkRouter from './main/check'
import gaugeRouter from './main/gauge'
import deliveryoutRouter from './main/deliveryout'
import blackWarehouseRouter from './main/blackWarehouse'

import supplierManagementRouter from './main/supplierAppointmentManagement'
import store from '@/store'

export const firstMenus = {
  router: '/',
  name: '首页',
  icon: 'el-icon-view',
  pid: 0,
}


const routes: RouteRecordRaw[] = [
  {
    path: '/redirect',
    component: Layout,
    meta: {
      hidden: true
    },
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/views/main/redirect.vue')
    }]
  },
  {
    path: '/',
    // redirect: '/dashboard',
    component: Layout,
    name: 'Layout',
    meta: {
      icon: 'el-icon-view',
      title: '首页'
    },
    children: [
      {
        path: '/dashboard',
        component: () => import('@/views/main/analysis/dashboard/dashboard.vue'),
        name: 'dashboard',
        meta: {
          icon: 'el-icon-view',
          title: '首页'
        }
      },
      {
        path: '/gyxHomePage',
        component: () => import('@/views/main/analysis/gyxHomePage/gyxHomePage.vue'),
        name: 'gyxHomePage',
        meta: {
          icon: 'el-icon-view',
          title: '首页'
        }
      }
    ]
  },

  systemRouter,
  platformRouter,
  warehouseRouter,
  invoicesRouter,
  missionRouter,
  tagPrintingRouter,
  statisticalRouter,
  checkRouter,
  gaugeRouter,
  supplierRouter,
  deliveryoutRouter,
  blackWarehouseRouter,
  supplierManagementRouter,
  {
    path: "/login",
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/not-found/NotFound.vue")
  }
];

const router = createRouter({
  routes,
  history: createWebHashHistory()
});


router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next) => {
  if (to.path === '/login') {
    next();
  } else {
    const token = localCache.getCache("token");
    const identity = localCache.getCache("identity");
    if (!token) {
      next('/login');
    } else {
      //判断用户信息是否存在，如果存放，用户登录状态，直接放行，用户信息不存在，获取用户信息，获取全局使用枚举  
      const userInfo = store.state.login.userInfo;
      if (Object.keys(userInfo).length == 0) {
        store.dispatch('login/userInfoAction')
        store.dispatch('login/getEnums')
      }
      if (to.path == '/') {
        const path = identity == 'SuperAdmin' || identity == 'Admin' ? '/dashboard' : '/gyxHomePage'
        next(path)
        return
      }
      next();
    }
  }



});
export default router;
